import { Component } from '@angular/core';
import { MainPage, NavController, ToastController, ErrorResult, LocalStorageService, AlertController, App, UserService } from '../mainpage';
import { ContestService } from '../../providers/contest';
import { GameGroup } from '../../entities/gamegroup';
import { Rank } from '../../entities/rank';

/*
declare function Teste();
declare var fingerprint;
declare function encryptData(data): any;
declare function decrypt(data): any;
*/

@Component({ 
  selector: 'page-ticketgroup',
  templateUrl: 'ticketgroup2.html'
})

export class TicketGroupPage extends MainPage {
    public gameGroups: GameGroup[];
    public selectedGroup: GameGroup;
    public rankInfo: Rank[];
    constructor(public navCtrl: NavController, protected toastCtrl: ToastController, 
        public localStorageService: LocalStorageService, public contestService: ContestService, 
        protected alertController: AlertController,
        protected userService: UserService,
        protected appCtrl: App) {
        super(navCtrl, toastCtrl, localStorageService, alertController, userService, appCtrl);
        this.loadPage();
    }

    public loadPage(): void {
        this.presentToast(" O grupo é para fazermos uma confraternização no fim do ano, os 10 ultimos por rodada pagarão R$5,00 para a realização de um churrasco no fim do ano, para participar entrar em contato via WhatsApp (37)99856-0090 .")
        this.contestService.getGroups().then((data: GameGroup[]) => {
            this.groupsLoaded(data);
        }).catch((err) => {
            this.getError(<ErrorResult>err);
          }); 
    }

    public groupsLoaded(gameGroup: GameGroup[]): void {
        this.gameGroups = gameGroup;
        for(var i=0; i<this.gameGroups.length; i++) {
            if (this.gameGroups[i].IsDefault) {
                this.selectedGroup = this.gameGroups[i];
                break;
            }
        }
        this.loadRank();
    }

    loadRank(): void {
        this.contestService.getRankGroup(1, this.selectedGroup.GameGroupId).then((data: Rank[]) => {
            this.rankLoaded(data);
        }).catch((err) => {
            this.getError(<ErrorResult>err);
          }); 
    }

    rankLoaded(groupRank: Rank[]): void {
        this.rankInfo = groupRank;
    }

    changeGroup(): void {
        this.loadRank();
    }

    public compareGroup(g1: GameGroup, g2:GameGroup): boolean {
        return g1.Fullname === g2.Fullname;
    }
}


// WEBPACK FOOTER //
// ./src/pages/contest/ticketgroup2.ts